module.exports = __webpack_public_path__ + "img/default_logo.50d6e2ff.png";